import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class BairroResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }

  listBairro(search) {
    const paramslist = {
      page: 1,
      sortBy: 'nome',
      sortDesc: false,
      itemsPerPage: -1,
      searchBy: null,
      searchJoinAnd: false,
      filterBy: 'id;nome',
    };
    if (search) {
      paramslist.searchBy = `nome:${search}`;
    }
    return this.search(paramslist);
  }

  listBairroCidade(cidadeId) {
    return this.http.get(`${this.resource}/${cidadeId}/cidade`);
  }
}

const resource = 'bairro';

const moduleHttp = new BairroResourceHttp(clientHttp, prefixBase + resource);

export default moduleHttp;
